import Activity from '../../schema/Activity';
import createActivityItem from './createActivityItem';

export default function populateActivities(activities: any, entities: any): Activity[] {
    if (activities) {
        let parsedActivities: Activity[] = [];
        for (let i = 0; i < activities.length; i++) {
            let activityItem = activities[i];
            if (activityItem && entities && entities[activityItem.entityId]) {
                let newActivity: Activity = createActivityItem(activityItem, i);
                if (newActivity) {
                    parsedActivities.push(newActivity);
                } else {
                    return null;
                }
            }
        }

        if (parsedActivities.length == 0) {
            return null;
        } else {
            return parsedActivities;
        }
    }
    return null;
}
